// extracted by mini-css-extract-plugin
export default {"collapse-typography":"mainStyle_collapse-typography__y1pSU","custom-scrollbar":"mainStyle_custom-scrollbar__vK+Db"};